require('core-js');require('regenerator-runtime/runtime');// webpack
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Foundation
require('../../../wdh-foundation/dgs/dgs-api');
require('../../../wdh-foundation/dgs/dgs-events.js');
require('@demant/megamenu');
require('../../../wdh-foundation/dgs-utils/dgs-utils.js');
require('@demant/burgermenu');
require('@demant/legacy/googlemaps');
require('masonry-layout');
require('jquery-nice-select/js/jquery.nice-select.min.js');
require('jquery-ui-dist/jquery-ui.min.js');

// Feature
require('./feature/center-locator.js');
require('./feature/center-list-spot.js');
require('./feature/center-spot.js');
require('./feature/data-hierarchy-spot.js');
require('./feature/video-spot.js');
require('./feature/cookies.js');
require('./feature/form.js');
require('./feature/iframe.js');
require('./feature/image-spot.js');
require('./feature/intro-banner.js');
require('./feature/language-selector-spot.js');
require('./feature/rich-text.js');
require('./feature/search.js');
require('./feature/text-image-spot.js');
require('./feature/wdh-locations-spot');
require('./feature/resource-center.js');

// Project
require('../../corporate-template/js/project/main.js');
require('./project/header.js');
require('@demant/wdh-gdpr/lib/default.implementation.js');